{
  "familyId": "TAA-SOORT-LID",
  "questions": [
    {
      "id": "TAA-SOORT-LID-001",
      "familyId": "TAA-SOORT-LID",
      "module": "Taalbegrip",
      "tier": 3,
      "levelCode": "M6",
      "group": 6,
      "skill": "woordsoorten",
      "subSkill": "srt_lid_znw",
      "questionType": "multiple_choice",
      "question": "Welk woord is een zelfstandig naamwoord in deze zin? 'De kat slaapt op de bank.'",
      "context": null,
      "options": ["kat", "slaapt", "op", "de"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "data": {
            "title": "Zelfstandig naamwoord herkennen",
            "content": "Een zelfstandig naamwoord is een woord voor een persoon, dier, ding of begrip. Je kunt er vaak 'de' of 'het' voor zetten. Test: de kat ✓, de slaapt ✗, de op ✗.",
            "icon": "lightbulb"
          },
          "showWhen": "wrong"
        }
      ],
      "conceptId": "noun_identification",
      "variantIndex": 1,
      "feedback": {
        "explanationText": "Regel: zelfstandig naamwoord herkennen. Strategie: een zelfstandig naamwoord is een woord voor een persoon, dier, ding of begrip — je kunt er 'de' of 'het' voor zetten. Stap 1: Test elk woord: de kat ✓ (dier), de slaapt ✗, de op ✗, de de ✗. Stap 2: 'Kat' is een dier → zelfstandig naamwoord. (Let op: 'bank' is ook een zelfstandig naamwoord in deze zin.)",
        "distractorExplanations": {
          "0": "Correct! 'Kat' is een zelfstandig naamwoord: het is een dier en je kunt er 'de' voor zetten (de kat).",
          "1": "Veelgemaakte fout: een werkwoord aanzien voor een zelfstandig naamwoord. 'Slaapt' is een werkwoord (persoonsvorm) — het geeft een handeling aan. Test: 'de slaapt' klinkt fout → geen zelfstandig naamwoord.",
          "2": "Veelgemaakte fout: een voorzetsel aanzien voor een zelfstandig naamwoord. 'Op' is een voorzetsel dat een relatie aangeeft (waar?). Test: 'de op' klinkt fout → geen zelfstandig naamwoord.",
          "3": "Veelgemaakte fout: een lidwoord verwarren met een zelfstandig naamwoord. 'De' is een lidwoord dat vóór het zelfstandig naamwoord staat. Het zelfstandig naamwoord is het woord erna: kat."
        }
      }
    },
    {
      "id": "TAA-SOORT-LID-002",
      "familyId": "TAA-SOORT-LID",
      "module": "Taalbegrip",
      "tier": 3,
      "levelCode": "M6",
      "group": 6,
      "skill": "woordsoorten",
      "subSkill": "srt_lid_znw",
      "questionType": "multiple_choice",
      "question": "Welk lidwoord hoort bij het woord 'huis'?",
      "context": null,
      "options": ["het", "de", "een (alleen)", "geen lidwoord"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "data": {
            "title": "De of het?",
            "content": "In het Nederlands zijn er twee bepaalde lidwoorden: 'de' en 'het'. 'Het' gebruik je bij onzijdige woorden (het-woorden). 'Huis' is een het-woord: het huis.",
            "icon": "lightbulb"
          },
          "showWhen": "wrong"
        }
      ],
      "conceptId": "article_het_de",
      "variantIndex": 2,
      "feedback": {
        "explanationText": "Regel: de/het-woorden. Strategie: je moet per woord onthouden of het een de-woord of een het-woord is. Stap 1: 'Huis' is een het-woord → het huis. Stap 2: In het meervoud krijgen alle woorden 'de': de huizen. Tip: verkleinwoorden zijn altijd het-woorden (het huisje).",
        "distractorExplanations": {
          "0": "Correct! 'Huis' is een het-woord: het huis.",
          "1": "Veelgemaakte fout: 'de' gebruiken bij een het-woord. 'Huis' is een het-woord, niet een de-woord. Je zegt 'het huis', niet 'de huis'. Dit moet je per woord onthouden.",
          "2": "Veelgemaakte fout: denken dat 'een' het enige lidwoord is. 'Een' is het onbepaalde lidwoord (een huis), maar de vraag is naar het bepaalde lidwoord. Bij 'huis' is dat 'het' (het huis).",
          "3": "Veelgemaakte fout: denken dat een woord geen lidwoord heeft. 'Huis' is een zelfstandig naamwoord en heeft altijd een lidwoord nodig: het huis (bepaald) of een huis (onbepaald)."
        }
      }
    },
    {
      "id": "TAA-SOORT-LID-003",
      "familyId": "TAA-SOORT-LID",
      "module": "Taalbegrip",
      "tier": 3,
      "levelCode": "M6",
      "group": 6,
      "skill": "woordsoorten",
      "subSkill": "srt_lid_znw",
      "questionType": "multiple_choice",
      "question": "Hoeveel zelfstandige naamwoorden staan er in deze zin? 'De jongen gooit de bal in de tuin.'",
      "context": null,
      "options": ["3", "2", "1", "4"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "data": {
            "title": "Zelfstandige naamwoorden tellen",
            "content": "Zoek alle woorden voor personen, dieren, dingen of begrippen. In deze zin: jongen (persoon), bal (ding), tuin (ding) = 3 zelfstandige naamwoorden.",
            "icon": "lightbulb"
          },
          "showWhen": "wrong"
        }
      ],
      "conceptId": "noun_counting",
      "variantIndex": 3,
      "feedback": {
        "explanationText": "Regel: zelfstandige naamwoorden tellen. Strategie: zoek alle woorden voor personen, dieren, dingen of begrippen — test met 'de/het'. Stap 1: de jongen ✓ (persoon). Stap 2: de bal ✓ (ding). Stap 3: de tuin ✓ (ding). Totaal: 3 zelfstandige naamwoorden. Let op: 'gooit' (werkwoord) en 'in' (voorzetsel) zijn geen zelfstandige naamwoorden.",
        "distractorExplanations": {
          "0": "Correct! Er staan 3 zelfstandige naamwoorden: jongen, bal en tuin.",
          "1": "Veelgemaakte fout: één zelfstandig naamwoord over het hoofd zien. Bij 2 vergeet je waarschijnlijk 'jongen' (persoon). Alle drie — jongen, bal en tuin — zijn zelfstandige naamwoorden.",
          "2": "Veelgemaakte fout: alleen het meest opvallende woord tellen. Er zijn meer dan 1 zelfstandig naamwoord. Test elk woord met 'de/het': de jongen ✓, de bal ✓, de tuin ✓ = 3.",
          "3": "Veelgemaakte fout: andere woordsoorten meetellen. Er zijn 3, niet 4 zelfstandige naamwoorden. 'Gooit' is een werkwoord, 'in' is een voorzetsel, en 'de' is een lidwoord — die tellen niet mee."
        }
      }
    },
    {
      "id": "TAA-SOORT-LID-004",
      "familyId": "TAA-SOORT-LID",
      "module": "Taalbegrip",
      "tier": 3,
      "levelCode": "M6",
      "group": 6,
      "skill": "woordsoorten",
      "subSkill": "srt_lid_znw",
      "questionType": "multiple_choice",
      "question": "Welk woord is een lidwoord in deze zin? 'Een vogel zingt in het bos.'",
      "context": null,
      "options": ["Een", "vogel", "zingt", "bos"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "data": {
            "title": "Lidwoorden herkennen",
            "content": "Lidwoorden staan vóór een zelfstandig naamwoord. Er zijn drie lidwoorden: de, het, een. In deze zin: 'Een' staat voor 'vogel' en 'het' staat voor 'bos'.",
            "icon": "lightbulb"
          },
          "showWhen": "wrong"
        }
      ],
      "conceptId": "article_identification",
      "variantIndex": 4,
      "feedback": {
        "explanationText": "Regel: lidwoorden herkennen. Strategie: lidwoorden staan altijd vóór een zelfstandig naamwoord. Er zijn drie lidwoorden in het Nederlands: de, het, een. Stap 1: 'Een' staat voor 'vogel' → lidwoord ✓. Stap 2: 'Het' staat voor 'bos' → ook een lidwoord. Stap 3: 'Een' is het onbepaalde lidwoord (je weet niet welke vogel).",
        "distractorExplanations": {
          "0": "Correct! 'Een' is een onbepaald lidwoord. Het staat voor het zelfstandig naamwoord 'vogel'.",
          "1": "Veelgemaakte fout: een zelfstandig naamwoord verwarren met een lidwoord. 'Vogel' is een zelfstandig naamwoord (een dier). Het lidwoord staat ervóór: een vogel.",
          "2": "Veelgemaakte fout: een werkwoord aanzien voor een lidwoord. 'Zingt' is een werkwoord (persoonsvorm). Lidwoorden zijn alleen: de, het, een.",
          "3": "Veelgemaakte fout: een zelfstandig naamwoord verwarren met een lidwoord. 'Bos' is een zelfstandig naamwoord (een ding/plek). Het lidwoord staat ervóór: het bos."
        }
      }
    },
    {
      "id": "TAA-SOORT-LID-005",
      "familyId": "TAA-SOORT-LID",
      "module": "Taalbegrip",
      "tier": 3,
      "levelCode": "M6",
      "group": 6,
      "skill": "woordsoorten",
      "subSkill": "srt_lid_znw",
      "questionType": "multiple_choice",
      "question": "Welk woord is GEEN zelfstandig naamwoord? 'De fietser rijdt over de brug.'",
      "context": null,
      "options": ["rijdt", "fietser", "brug", "De"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "data": {
            "title": "Werkwoord vs. zelfstandig naamwoord",
            "content": "Een zelfstandig naamwoord is een persoon, dier, ding of begrip. Een werkwoord geeft een handeling aan. 'Rijdt' is een handeling (werkwoord). 'Fietser' en 'brug' zijn zelfstandige naamwoorden.",
            "icon": "lightbulb"
          },
          "showWhen": "wrong"
        }
      ],
      "conceptId": "noun_vs_verb",
      "variantIndex": 5,
      "feedback": {
        "explanationText": "Regel: woordsoorten onderscheiden. Strategie: test elk woord — is het een persoon/dier/ding/begrip (zelfstandig naamwoord) of een handeling (werkwoord)? Stap 1: 'rijdt' = handeling (werkwoord/persoonsvorm) → geen zelfstandig naamwoord ✓. Stap 2: 'fietser' = persoon → zelfstandig naamwoord. 'brug' = ding → zelfstandig naamwoord. 'De' = lidwoord.",
        "distractorExplanations": {
          "0": "Correct! 'Rijdt' is een werkwoord (persoonsvorm) — het geeft een handeling aan, geen persoon, dier of ding.",
          "1": "Veelgemaakte fout: een zelfstandig naamwoord kiezen bij een 'GEEN'-vraag. 'Fietser' is wél een zelfstandig naamwoord (persoon). Lees de vraag goed: welk woord is GEEN zelfstandig naamwoord? Dat is 'rijdt' (werkwoord).",
          "2": "Veelgemaakte fout: een zelfstandig naamwoord kiezen bij een 'GEEN'-vraag. 'Brug' is wél een zelfstandig naamwoord (ding). Lees de vraag goed: welk woord is GEEN zelfstandig naamwoord? Dat is 'rijdt' (werkwoord).",
          "3": "Veelgemaakte fout: het lidwoord kiezen in plaats van het werkwoord. 'De' is inderdaad geen zelfstandig naamwoord (het is een lidwoord), maar 'rijdt' (werkwoord) is het duidelijkste antwoord — het is een compleet andere woordsoort."
        }
      }
    }
  ]
}